const AUTH0_SENDER_DOMAIN = 'littlebird.ai';

const GMAIL_TEMPLATE =
  'https://mail.google.com/mail/u/0/?authuser={USER_EMAIL}#search/from%3A({FROM})+in%3Aanywhere+newer_than%3A1d';

function isGmail(email: string): boolean {
  const domain = email.split('@')[1]?.toLowerCase();
  return !!domain && /^(gmail|googlemail|google)\.com$/.test(domain);
}

export function getSniperLink(email: string): {
  provider: 'google';
  label: string;
  url: string;
} | null {
  if (!isGmail(email)) return null;

  const url = GMAIL_TEMPLATE.replace(
    '{USER_EMAIL}',
    encodeURIComponent(email)
  ).replace('{FROM}', AUTH0_SENDER_DOMAIN);

  return { provider: 'google', label: 'Gmail', url };
}
